import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { PolicyStatusEnum } from '../enums/policy-status.enum';
import { PolicyTypeEnum } from '../enums/policy-type.enum';

/**
 * Policy DTO for lists and search
 */
@CaslSubject(AppSubjectEnum.POLICY)
export class PolicyListDto extends BaseSearchDto {
	type!: PolicyTypeEnum;
	name?: string | null;
	notes?: string | null;
	status!: PolicyStatusEnum;
}
